import ProductFiftyFifty from './ProductFiftyFifty'

export default ProductFiftyFifty
